import { useSnapshot } from 'valtio'
import { useVersionQuery } from '@queries/version'
import { APP_VERSION } from '@shared/config/version'
import { versionStore } from '@store/versionStore'

export function useVersionMismatch() {
  const { data } = useVersionQuery()
  const { dismissedVersion } = useSnapshot(versionStore)

  const serverVersion = data?.version ?? null
  const isDifferent = serverVersion !== null && serverVersion !== APP_VERSION
  const isDismissed = serverVersion === dismissedVersion
  const isMismatch = isDifferent && !isDismissed

  return { isMismatch, latestVersion: serverVersion }
}
